import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import Select from "react-select";
import { components } from "react-select";
import editIcon from "../../assets/images/register/edit.png";
import validIcon from "../../assets/images/register/green_check.svg";
import indiaFlag from "../../assets/images/register/india.svg";
import { connect } from "react-redux";
import {
  mobile_number,
} from "../../constants/registration";
import { deviceType, getAbsoluteDestinationUrl } from "../../utils/registrationUtils";
import CommonModal from "../utils/commonModal";
import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import { countryCodeStyleDesktop, countryCodeStyleMobile } from "./registrationUtils/styles"
import { useNavigate } from "react-router-dom";
import {clearUserLoginSignupOtpResponse} from "../../../store/slices/Registration/CommonSlices"
import {gaEvent, gaLocationAndContentData} from "../../utils/index";

const CareersRegisterInputMobile = (props) => {
  const navigate = useNavigate()
  const { values, setFieldValue, errors, touched, handleBlur, locationData } = props;
  const [overlayActive, setOverlayActive] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({});
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false)
  const mobileInputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [showSuccessCard, setShowSuccessCard] = useState(false);
  let defaultCountry = props.countryCodeData?.values?.find((item) => item.value == "+91")
  const cookies = new Cookies();
  let destinationUrl = getAbsoluteDestinationUrl();

  const { otpVerifyCheck, otpVerifyLoading,  otpVerifyError} = useSelector((state) => state.usersGoogleSiginIn)
  
  const userInfoVerifcation = {
    otpVerify: window.location.href.includes("/user/otp-verify"),
    userRegister: window.location.href.includes("/user/register"),
    updateProfile: window.location.href.includes("/user/update-profile"),
    completeProfile: window.location.href.includes("/user/complete-profile"),
    isProfileCheck: window.location.href.includes("/user/complete-profile") || window.location.href.includes("/user/update-profile"),
    emailRequired: props.loginDatas?.required_field?.length > 0 && ['email', 'email_confirm', 'email_otp']?.includes(props.loginDatas?.required_field?.[0]),
    otpLoginState: (cookies?.get("loginState")?.mobileVerifyParams?.otp),
    editMobile: ((isEditClicked && props.editMobile) || props.formCurrentState?.isMobileEditing),
    auth : values?.mobile?.length === 10 && props.userAuthenticationErrors?.authorization != false,
    checkValues: values?.mobile && !errors.mobile && !mobile_number.test(values.mobile),
    usersAuthentication: props.userAuthenticationErrors?.authorization,
    isUpdateProfileCheck: window.location.href.includes("/user/update-profile")
  };
  const userLimitCheck = userInfoVerifcation?.isUpdateProfileCheck ? true : props.userAccountLimitCheck?.authorization;

  useEffect(() => {
    setSelectedCountry(defaultCountry)
  }, [props.countryCodeData])

  useEffect(() => {
    if (props.formCurrentState?.isMobileEditing) {
      setTimeout(() => {
        if (mobileInputRef.current) {
          mobileInputRef.current.focus();
        }
      }, 10)
    }
  }, [])

  // to show sent otp success card only for 5 sec.
  useEffect(() => {
    if (props.usersLoginSignupOtp) {
      setShowSuccessCard(true);
      const timeout = setTimeout(() => {
        setShowSuccessCard(false);
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [props.usersLoginSignupOtp]);

  useEffect(() => {
    if(userInfoVerifcation.isProfileCheck && otpVerifyCheck){
      if(userInfoVerifcation?.updateProfile){
        gaEvent("mobileverifyupdateprofile", "login_signup", `${gaLocationAndContentData}`, "");
      }else{
        gaEvent("mobileverifycompleteprofile", "login_signup", `${gaLocationAndContentData}`, "");
      }
    }
  },[otpVerifyCheck])

  const handleEdit = (e) => {
    if(userInfoVerifcation?.updateProfile){
      gaEvent("changemobileupdateprofile", "login_signup", `${gaLocationAndContentData}`, "");
    }else if(userInfoVerifcation?.completeProfile){
      gaEvent("changemobilecompleteprofile", "login_signup", `${gaLocationAndContentData}`, "");
    }else{
      gaEvent("otpchangemobilesignup", "login_signup", `${gaLocationAndContentData}`, "");
    }
    props.dispatch(clearUserLoginSignupOtpResponse())
    {userInfoVerifcation.isProfileCheck && 
      props.setFormikValues((prev) => ({...prev, "otp": ""}));
      props.setReinitialize(true);
      setTimeout(() => props.setReinitialize(false), 0);
    }
    setShowSuccessCard(false); // to stop otp success card on edit.
    setIsEditClicked(true);
    props.setFormCurrentState((prev) => ({
      ...prev, isMobileEditing: true
    }))

    setTimeout(() => {
      props.setEditMobile(true)
      if (mobileInputRef.current) {
        mobileInputRef.current.focus();
      }
    }, 10)
  }

  const handleInputBlur = () => {
    props.setIsMobileFocused(false);
  }
  const MenuList = (props) => {
    return (
      <div>
        <components.MenuList {...props}>
          <span className="country_code_heading">Select country code</span>
          {/* <input type="text" className="country_code_search" placeholder="Search.." /> */}
          {props.children}
        </components.MenuList>
      </div>
    )
  };

  const handleCountry = (obj) => {
    setSelectedCountry(obj);
    // setOpen(false);
    setShowModal(false)
    if (deviceType == "web") {
      setOpen(!open);
    }
  };

  const handleFocus = (event) => {
    setOverlayActive(true)
    props.updateTouchedFields({ ...touched, [`${props.name}`]: true })
  };

  const handleIsFocused = () => {
    setFocused(true)
    props.setIsMobileFocused(true)
    if (deviceType == "mobile") {
      setShowModal(true);
    }
    props.updateTouchedFields({ ...touched, [`${props.name}`]: true })
  }
  const handleOpenCountryList = () => {
    if (deviceType == "web") {
      setOpen(!open);
    }
    if (deviceType == "mobile") {
      setShowModal(true)
      setOpen(true);
    }
  }
  const shouldDisplayEditButton = () => {
    if(!userInfoVerifcation.editMobile){
      if(userInfoVerifcation?.isProfileCheck && (props.usersLoginSignupOtp || 
        props.usersLoginSignupOtpError?.block_user_case == "try_again") && !otpVerifyCheck ){
        return true
      }else if(userInfoVerifcation.otpVerify){
        return true
      }
    }
  };

  const showEditIcon = () => {
    return (
      <div onClick={handleEdit} className="edit_card">
        <img src={editIcon} alt="edit_icon" />
        <span>Edit</span>
      </div>)
  }

  const showSendOtpIcon = () => {
    return (
         <span onClick={() => {props.otpGetClicked(); props.resetTimer();}} className="send_otp_profile_button">Send OTP</span>
    )
  }

  // To show valid icon

  const validationIcon = () => {
    return (
      <img
        src={validIcon}
        alt="careers_register_checkIcon"
        className="careers_register_valid_icon"
      />
    )
  }
  const isShowValidateIcon = () => {
    if(userInfoVerifcation?.isProfileCheck && otpVerifyCheck){ //check added for complete and update profile
       return true;
    }else if (userInfoVerifcation.userRegister &&
      userInfoVerifcation.checkValues && userInfoVerifcation.auth) {
      return true;
    }
  }
  const isShowValidateIconOnVerify = () => {
    if (userInfoVerifcation.otpVerify && userInfoVerifcation.editMobile && props.usersAuthentication) {
      return true;
    }
  }

  const isShowSendOtpButton = () => {
    if(userInfoVerifcation.isProfileCheck && props.usersAuthentication && userLimitCheck && !errors.mobile  && (userInfoVerifcation.editMobile ? !errors.mobile 
      : !userInfoVerifcation.editMobile) && !otpVerifyCheck && !props.usersLoginSignupOtp && props.usersLoginSignupOtpError?.block_user_case != "try_again"){
      return true;
    }
  }

  // for input box
  const renderMobileInput = (type) => {
    return (
      <>
      <input
        type="text"
        className="input_type_number"
        name="mobile"
        onBlur={(e) => {
          handleBlur({ target: { [props.name]: e} });
          handleInputBlur(e);
          props.updateTouchedFields({ ...touched, [`${props.name}`]: true });
          props.setTouched({ ...touched, ["mobile"]: true});
        }}
        maxLength={10}
        onChange={(e) => {
          // Get the current input value
            const rawValue = e.target.value;
            // Sanitize the input to allow only digits
            const sanitizedValue = rawValue.replace(/[^\d]/g, '');
            // If the input length exceeds 10, prevent updating the value further
            if (sanitizedValue.length > 10) {
              return;
            }
          setFieldValue("mobile", sanitizedValue);
          props.setSyncSignupValues((prev) => ({ ...prev, "mobile": sanitizedValue }))
        }}
        value={values?.mobile}
        onFocus={handleIsFocused}
        inputMode="numeric"
        ref={type === "login" ? null : mobileInputRef}
      />
        {type === "otpVerify" && <span className={values?.mobile ? 'floating_label_active' : (!focused && !touched?.mobile && !values?.mobile) ? 'floating_label_mobile' : 'floating_label'}>OTP sent to</span>}
    </>
    );
  };
  return (
    <div className={((errors?.mobile && touched?.mobile) || props.userAuthenticationErrors?.authorization == false) ? "careers_register_mobile_card invalid_field" : values?.mobile ? "careers_register_mobile_card white_bg" : "careers_register_mobile_card"}>
      {deviceType == 'web' && open && selectedCountry?.value != "+91" &&
        <div className="register_country_code_drop_down_cover">
          <div className="register_country_code_drop_down">
            <Select
              menuIsOpen={open}
              placeholder={selectedCountry?.country_image}
              isSearchable
              isDisabled={selectedCountry?.value == "+91"}
              options={props.countryCodeData?.values}
              getOptionLabel={(opt) => `${opt?.country_image}  ${opt?.country__name}`}
              getOptionValue={(opt) => opt?.country_id}
              value={selectedCountry}
              components={{ MenuList: MenuList }}
              onChange={(obj) => handleCountry(obj)}
              styles={countryCodeStyleDesktop}
            />
          </div>
        </div>
      }


      {deviceType == 'mobile' && open && selectedCountry?.value != "+91" &&
        <CommonModal
          isOpen={showModal}
          closeModal={() => setShowModal(false)}
          classNames={{
            root: "mobile_modal mobile_modal_email",
            modal: 'custom_modal',
            modalAnimationIn: 'customEnterModalAnimation',
            modalAnimationOut: 'customLeaveModalAnimation',
          }}
          animationDuration={800}
        >

          <Select
            placeholder={selectedCountry?.country_image}
            isDisabled={selectedCountry?.value == "+91"}
            menuIsOpen
            // isSearchable={true}
            options={props.countryCodeData?.values}
            getOptionLabel={(opt) => `${opt?.country_image}  ${opt?.country__name}`}
            getOptionValue={(opt) => opt?.country_id}
            value={selectedCountry}
            onChange={(obj) => handleCountry(obj)}
            components={{ MenuList: MenuList }}
            onBlur={
              overlayActive ? setOverlayActive(false)
                : handleBlur(name)
            }
            onFocus={handleFocus}
            styles={countryCodeStyleMobile}
          />
        </CommonModal>
      }

      {/* <div className="overlayMobile"></div> */}
      {(focused || touched?.mobile || props.values?.mobile) && (<>
        <span className={"register_country_logo_margin"} onClick={handleOpenCountryList}>
          <img src={indiaFlag} alt="indiaFlag" />
        </span>
        <span className="register_country_code">+91</span>
      </>)}
      <div className="careers_register_mobile_number">
        {(userInfoVerifcation.userRegister || userInfoVerifcation.isProfileCheck) &&
          <>
            {userInfoVerifcation.isProfileCheck && (shouldDisplayEditButton() || otpVerifyCheck) ? 
            <input
                  type="text"
                  name="mobile"
                  className="input_type_number"
                  // placeholder={props.placeholder}
                  value={values?.mobile}
                  readOnly
                /> : renderMobileInput("login")}
            <span className={props.values?.mobile ? 'floating_label_active' : (!focused && !touched?.mobile && !props.values?.mobile) ? 'floating_label_mobile' : 'floating_label'}>Mobile Number</span>
          </>}
        {userInfoVerifcation.otpVerify &&
          <>{((isEditClicked && props.editMobile) || props.formCurrentState?.isMobileEditing) ?
            renderMobileInput("otpVerify") :
            (
              <>
                <input
                  type="text"
                  name="mobile"
                  className="input_type_number"
                  // placeholder={props.placeholder}
                  value={values?.mobile}
                  readOnly
                />
                <span className={props.values?.mobile ? 'floating_label_active' : (!focused && !touched?.mobile && !props.values?.mobile) ? 'floating_label_mobile' : 'floating_label'}>OTP Sent to</span>
              </>
            )
          }</>}
      </div>
      {isShowSendOtpButton() && showSendOtpIcon()}
      {isShowValidateIcon() && validationIcon()}

      {isShowValidateIconOnVerify() && validationIcon()}

      {/* {isShowEdit() && showEditIcon()} */}
      {
        shouldDisplayEditButton() && (
          showEditIcon()
        )
      }
      {
        userInfoVerifcation.otpVerify &&
        props.postSignupData &&
        !props.editMobile && !props.formCurrentState?.isMobileEditing && props.usersAuthentication && (
          showEditIcon()
        )
      }
      {
        userInfoVerifcation.isProfileCheck && showSuccessCard && !userInfoVerifcation?.editMobile && 
          <div className="invalid_card">
            <span className="otp_has_been_sent">
              OTP has been sent to this number.
            </span>
          </div>
      }
     
      {errors.mobile && touched?.mobile && (
        <div className="invalid_card">
          <span className="invalid_card_text">{errors.mobile}</span>
        </div>
      )}
      {(props.userAuthenticationErrors?.authorization == false || props.usersLoginSignupOtpError?.block_user_case == "user_restricted" 
        || props.usersLoginSignupOtpError?.block_user_case == "otp_exceed") && !errors.mobile && (
        <div className="invalid_card">
          <span className="invalid_card_text">Mobile error, <a href="https://www.careers360.com/grievance-redressal" className="contact_support_text">contact support</a></span>
        </div>
      )}
      {props.userAccountLimitError?.block_user_case == "account_limit_exceed" && !errors.mobile && 
      <div className="invalid_card">
          <span className="invalid_card_text">Mobile error, try  <a href= {`${window.location.origin}/user/login${window.location.search}`} className="contact_support_text">login </a> or <a href="https://www.careers360.com/grievance-redressal" target="_blank" rel="noopener noreferrer" className="contact_support_text">contact support</a></span>
        </div>}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    userIps: state.usersCommonData?.userIp,
    countryCodeData: state.usersCommonData?.countryCode,
    userAuthenticationErrors: state.usersCommonData?.userAuthenticationError,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    usersAuthentication: state.usersCommonData?.userAuthentication,
    userAccountLimitCheck: state.usersCommonData?.userAccountLimit,
    userAccountLimitError: state.usersCommonData?.userAccountLimitError,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterInputMobile);


